export const ADD_DOCUMENT_TO_SELECTION =
  "documentLabels/ADD_DOCUMENT_TO_SELECTION";
export const REMOVE_DOCUMENT_FROM_SELECTION =
  "documentLabels/REMOVE_DOCUMENT_FROM_SELECTION";
export const CLEAR_DOCUMENT_SELECTION =
  "documentLabels/CLEAR_DOCUMENT_SELECTION";
export const UPDATE_DOCUMENT_IN_SELECTION =
  "documentLabels/UPDATE_DOCUMENT_IN_SELECTION";

export const addDocumentToSelection = (document) => {
  return async (dispatch) => {
    dispatch({
      type: ADD_DOCUMENT_TO_SELECTION,
      payload: { ...document },
    });
  };
};

export const removeDocumentFromSelection = (document) => {
  return async (dispatch) => {
    dispatch({
      type: REMOVE_DOCUMENT_FROM_SELECTION,
      payload: document,
    });
  };
};

export const clearDocumentSelection = () => {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_DOCUMENT_SELECTION,
    });
  };
};

export const updateDocumentInSelection = (updatedDocument) => {
  return async (dispatch) => {
    dispatch({
      type: UPDATE_DOCUMENT_IN_SELECTION,
      payload: updatedDocument,
    });
  };
};

export default {
  addDocumentToSelection,
  removeDocumentFromSelection,
  clearDocumentSelection,
  updateDocumentInSelection,
};
